/*
  Going somewhere new starts at the top of it.

  The app never navigates: every screen is a state change inside one document, so the
  scroll position simply stays wherever the last screen left it. Open a seat from the
  fourth row of the roster and the editor opens already scrolled past the portrait, which
  is the one thing on that screen you want to see first.

  A real router would do this. There isn't one, and adding it to fix a scroll position
  would be the wrong order of operations.
*/

/**
 * The top of the page, immediately.
 *
 * Not smooth. Smooth scrolling is for a movement the owner asked for and can follow, like
 * an agenda item scrolling itself into view. Animating the jump between two screens shows
 * them a fast tour of a screen they have already left.
 *
 * Both targets because the document is `html, body { height: 100% }` here, and which
 * element ends up the scrolling one differs between engines. Setting the one that is not
 * scrolling costs nothing.
 */
export function toTop(): void {
  window.scrollTo(0, 0)

  const el = document.scrollingElement ?? document.documentElement
  el.scrollTop = 0
}
